<div class="filter-container">
  <div class="filter-topics">
    <header>
      <span>{{ title }}</span>
      @if (filterActive) {
        <span class="text negative reset-filters pull-right" (click)="doResetFilter()">
          <fa-icon [icon]="faCircleXmark"></fa-icon>
          <span>Reset filters</span>
        </span>
      }
    </header>

    <div class="topic-list">
      <rcp-option-list>
        @for (topic of options; track topic) {
          <div
            (click)="selectOption(topic)"
            [class.active]="topic === selectedOption && (topic.children || topic.optionGroups)"
            class="topic-list-item clickable"
          >
            <div class="topic-list-item-checkbox">
              @if (topicListItem) {
                <ng-container
                  [ngTemplateOutlet]="topicListItem"
                  [ngTemplateOutletContext]="{ topic: topic, setAllOptionsSelected: setAllOptionsSelected.bind(this) }"
                />
              } @else {
                <span>{{ topic.label }}</span>
              }
            </div>
            @if (topic.children?.length) {
              <fa-icon [icon]="faAngleRight" size="1x" />
            }
          </div>
        }
      </rcp-option-list>
    </div>
  </div>

  @if (selectedOption; as selectedFilterOption) {
    @if (selectedFilterOption.children?.length || selectedFilterOption.optionGroups?.length) {
      <div class="option-list">
        @if (selectedFilterOption.children?.length) {
          @for (option of selectedFilterOption.children; track option) {
            <div
              class="option-list-item"
              [class.clickable]="!optionListItem"
              [class.selected]="!optionListItem && option.selected"
              (click)="defaultSelectOption(selectedFilterOption, option)"
            >
              @if (optionListItem) {
                <ng-container
                  [ngTemplateOutlet]="optionListItem"
                  [ngTemplateOutletContext]="{
                    option: option,
                    selectedOption: selectedFilterOption,
                    updateSelectableGroups: updateSelectableGroups.bind(this),
                  }"
                >
                </ng-container>
              } @else {
                <span>{{ option.label }}</span>
              }
            </div>
          }
        }
        @if (selectedFilterOption.optionGroups) {
          @for (optionGroup of selectedFilterOption.optionGroups; track optionGroup) {
            <div class="option-list-group">
              <header class="option-list-group-label">
                <span>{{ optionGroup.label }}</span>
              </header>
              @for (option of optionGroup.children; track option) {
                <div class="option-list-item">
                  <ng-container
                    [ngTemplateOutlet]="optionListItem"
                    [ngTemplateOutletContext]="{
                      option: option,
                      selectedOption: selectedFilterOption,
                      updateSelectableGroups: updateSelectableGroups.bind(this),
                    }"
                  >
                  </ng-container>
                </div>
              }
            </div>
          }
        }
      </div>
    }
  }
</div>
